

// update a State.field in the appcontext
//function reducer(State, action) {
const reducer = (State, action) => {
	//console.log("reducer: name="+name+"  event="+event.target.value);

	if(false) {
		console.log("reducer: caller="+action.type+"  ", action.value, new Error().stack);
	} else {
		//console.log("reducer: action=",action.type,"  ", action.value);
	}

	switch (action.type) {
	    case "RESET":
	      	return {}; 
	    case "phone_number":
	      	return { ...State, phone_number: action.value };
	    case "biz_name":
	      	return { ...State, biz_name: action.value };
	    default:
	      	return { ...State, [action.type]: action.value };;
	}
}

export default reducer;